export enum FundClassification {
  Welfare = 'Welfare',
  Community = 'Community',
  Kollel = 'Kollel',
  CampaignForWelfare = 'CampaignForWelfare',
  CampaignForCommunity = 'CampaignForCommunity',
}
